// The first row has no backend step id: the product choice is kept in the browser (OB-X-05), so
// `createSteps` gives it `stepId: null` and every consumer treats it by position, not by id.
export const STEPS = [
  {
    key: "features",
    label: "Choose your features",
    step: "FEATURES"
  },
  {
    key: "business-info",
    label: "Company profile",
    step: "COMPANY"
  },
  {
    key: "payment-connect",
    label: "Connect integration",
    step: "INTEGRATION"
  },
  {
    key: "enrollment",
    label: "Choose enrollment",
    step: "ENROLLMENT"
  },
  {
    key: "alerts",
    label: "Activate alerts",
    step: "ALERTS",
    subSteps: [
      {
        key: "billing",
        label: "Add billing descriptor"
      },
      {
        key: "bin",
        binLabel: "Add ARN codes",
        arnLabel: "Add BIN&CAID codes"
      }
    ]
  },
  {
    key: "card-info",
    label: "Link a card",
    step: "CARD"
  },
  {
    key: "top-up",
    label: "Top up your balance",
    step: "TOP_UP"
  }
]
